exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right23[data-v-2b33ae09] {\n  padding-right: 1.197917rem;\n}\n.redColor[data-v-2b33ae09] {\n  color: #f00;\n}", ""]);

// exports
